<template>
  <div class="main_wrap">
    <div class="row">
      <div class="col-xs-12 col-md-6 offset-md-3">
        <i class="fab fa-paypal"></i>
      </div>
      <div class="col-xs-12 col-md-12" style="padding: 2em; font-size: 18px">
        <p>
          Please wait while we redirect you to paypal.com to complete the order
        </p>
      </div>
    </div>
    <!-- test -->
    <div class="col-xs-12">
      <!-- <p>{{ finalOrder }}</p> -->

      <form method="POST" action="https://www.paypal.com/cgi-bin/webscr">
        <p>
          If you're not automatically redirected click
          <button
            class="btn-fake"
            type="submit"
            id="paypal"
            @click="redirect()"
          >
            PayPal.com
          </button>
        </p>
        <input type="text" name="custom" v-bind:value="finalOrder.tranID" />
        <input type="text" name="invoice" v-bind:value="finalOrder.tranID" />
        <input
          type="text"
          name="item_name"
          v-bind:value="'Order Number ' + finalOrder.tranID + ' HappyPurim'"
        />
        <input type="text" name="item_number" value="" />
        <input
          type="text"
          name="amount"
          v-bind:value="finalOrder.paypalTotal"
        />
        <input type="text" name="cmd" value="_xclick" />
        <input
          type="text"
          name="currency_code"
          v-bind:value="settings.currency"
        />
        <input
          type="text"
          name="notify_url"
          value="https://www.happypurim.com/paypalipnprocess.aspx"
        />
        <input
          type="text"
          name="return_url"
          value="https://www.happypurim.com/receipt.aspx?tran_id=1"
        />
        <input
          type="text"
          name="return_cancel"
          value="https://www.happypurim.com/receipt.aspx?id=1"
        />
        <input
          type="text"
          name="business"
          v-bind:value="settings.paypalUserName"
        />
        <input type="text" name="no_note" value="1" />
      </form>
    </div>
    <!-- test end -->
  </div>
</template>
<script>
import $ from "jquery";

export default {
  name: "PaypalPage",
  data: function() {
    return {
      list: [],
    };
  },
  methods: {
    redirect() {
      $("#paypal").click();
      //   setTimeout(() => this.$store.commit("resetCart", this.list), 3000);
    },
  },

  computed: {
    finalOrder() {
      let obj = this.$store.state.finalOrder;
      if (obj.totalDiscountedPrice > 0) {
        obj.paypalTotal = obj.totalDiscountedPrice;
      } else {
        obj.paypalTotal = obj.totalPrice;
      }
      return this.$store.state.finalOrder;
    },
    settings() {
      return this.$store.state.settings[0];
    },
  },
  created() {
    window.scrollTo(0, 0);
    let list = this.$store.state.list;
    for (var i = 0; i < list.length; i++) {
      if (!list[i].paid && list[i].selected) {
        this.list.push(list[i]);
      }
    }

    setTimeout(() => this.redirect(), 1000);
  },
};
</script>
<style scoped>
.main_wrap {
  padding: 3em;
}
.main_wrap .fa-paypal {
  font-size: 7em;
  color: #003087;
}
.btn-fake {
  border: none;
  background: none;
  text-decoration: underline;
  color: #3c91e8;
}
input[type="text"] {
  visibility: hidden;
}
</style>
